<template>
    <b-modal id="videoModel" hide-footer>
        <iframe id="videoFrame" :src="data.videoSrc" width="100%" height="480" frameborder="0" webkitallowfullscreen=""
            mozallowfullscreen=""></iframe>
    </b-modal>
</template>


<script>
export default {
    name: 'VideoPoup',
    props: {
        // Define the prop name and type
        videoData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: {}
        }
    },
    methods: {
    },
    watch: {
        videoData: {
            immediate: true, // Execute the handler immediately on mount
            handler(newData) {
                this.data = newData;
            }
        }
    }
}
</script>